const TableHeader = ({
  columns,
  headerClassName,
  headerTextClassName,
  language,
}) => (
  <thead className={headerClassName}>
    <tr>
      {columns.map((col, index) => {
        const header = col.header;

        const headerText =
          typeof header === "object"
            ? language
              ? header.hi
              : header.en
            : header;

        return (
          <th
            key={index}
            className={`border border-gray-400 p-2 text-center ${
              headerTextClassName || ""
            }`}
          >
            {headerText}
          </th>
        );
      })}
    </tr>
  </thead>
);

export default TableHeader;
